import { useMemo } from 'react';

export const useQueryParam = () =>
    useMemo(
        () => ({
            search: new URLSearchParams(window.location.search),
            pathname: window.location.pathname,
        }),
        [],
    );
